import React, { useState, useEffect } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import CatalogoClaseMinas from "../../catalogos/catalogoClaseMinas";
import useTableScroll from "../../components/useTableScroll.js";
import { formatMoneda } from "../../util/varios";

const TablaClaseMinas = (props) => {
  const [catalogo, setCatalogo] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);

  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const [records, setRecords] = useState([]);

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN.",
      textAlign: "center",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ALICUOTA.",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES.",
      textAlign: "center",
    },
  ];

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTableScroll(records, headCells, filterFn);

  useEffect(() => {
    if (props.tabclase) {
      setRecords(props.tabclase);
    }
  }, [props.tabclase]);

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const handleAceptaCatalogoClass = (idclass, descrip, codclass, ali) => {
    setCatalogo(false);
    props.seleccionarCampos(idclass, descrip, codclass, ali);
  };

  const handleEliminar = (idclass) => (e) => {
    e.preventDefault();

    props.eliminarCampos(idclass);
  };

  return (
    <div className="card">
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content">
          <div className="container">
            <div className="row col-md-12" style={{ height: "100%" }}>
              <div className="col-3 d-flex ml-auto">
                <button
                  onClick={handleCatalogo}
                  style={{ marginBottom: "5px" }}
                  disabled={
                    props.operacion === 4 || props.operacion === 3
                      ? true
                      : deshabilitado
                  }
                  className="btn btn-sm btn-primary rounded-pill ml-auto"
                >
                  <i className="fas fa-pen-square"></i> Incluir
                </button>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        records.map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              style={{
                                fontSize: "12px",
                                textAlign: "center",
                                width: "30px",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {item.codigoclaseminas}
                            </TableCell>
                            <TableCell
                              style={{
                                fontSize: "12px",
                                textAlign: "left",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {item.descripcion}
                            </TableCell>
                            <TableCell
                              style={{
                                fontSize: "12px",
                                textAlign: "center",
                                width: "30px",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {formatMoneda(
                                item.alicuota
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{
                                textAlign: "center",
                                width: "20px",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              <button
                                onClick={handleEliminar(item.idclaseminas)}
                                disabled={
                                  props.operacion === 4 || props.operacion === 3
                                    ? true
                                    : deshabilitado
                                }
                                className="btn btn-sm btn-danger rounded-circle"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              </div>
              <CatalogoClaseMinas
                show={catalogo}
                onHideCancelaCatClass={handleCatalogo}
                onHideAceptaCatClass={handleAceptaCatalogoClass}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaClaseMinas;



// WEBPACK FOOTER //
// ./src/components/minas/tablaClassR.js